import { render } from "./storeAddress.vue?vue&type=template&id=43ca8120&scoped=true"
import script from "./storeAddress.vue?vue&type=script&lang=js"
export * from "./storeAddress.vue?vue&type=script&lang=js"

import "./storeAddress.vue?vue&type=style&index=0&id=43ca8120&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ca8120"]])

export default __exports__